import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import ArticleContent from '../../../../../components/articleContent';

class MainContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pluginData: PropTypes.object,
        editorName: PropTypes.string,
        editorCode: PropTypes.string,
        hasCopyRight: PropTypes.object,
        sourceReason: PropTypes.string,
    };

    render() {
        const { content, pluginData, editorName, editorCode, sourceReason, hasCopyRight } = this.props;
        const isShowEditName = editorCode && (hasCopyRight || sourceReason === '公开信息');

        return (
            <div className={styles.main_content}>
                {content.contentList ? (
                    <div>
                        <ArticleContent content={content} pluginData={pluginData} />
                        {isShowEditName ? <p className={styles.author}>{`责编：${editorName} ${editorCode}`}</p> : ''}
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}

export default errorBoundary(MainContent);
